import { Form } from './types'

export enum FormKeys {
    Name = 'name',
    PrintTypes = 'printTypes',
    CharsPerLine = 'charsPerLine',
    PaperWidth = 'paperWidth',
}

export const defaultFormValues: Form = {
    name: '',
    printTypes: [],
    charsPerLine: '32',
    paperWidth: '58',
}
